import React from 'react';
import { HUMANS } from '../data/populations';
import { COMPILED_LABEL } from '../data/sources';
import { useScenario } from '../contexts/ScenarioContext';
import { formatCompact, formatInt } from '../utils/format';
import { CounterPanel } from '../components/census/CounterPanel';
import { ScenarioSwitcher } from '../components/census/ScenarioSwitcher';
import { RatioGauge } from '../components/census/RatioGauge';
import { QuickStats } from '../components/census/QuickStats';
import { PopulationBreakdown } from '../components/census/PopulationBreakdown';
import { SourceRef } from '../components/SourceRef';
import { AgentRatio } from '../components/census/AgentRatio';
export function Census() {
  const {
    scenario
  } = useScenario();
  return <>
      <section className="border-b border-line" data-id="element-960" data-mp="2mqkhxo9jqaz">
        <div className="mx-auto max-w-[1400px] px-5 pb-12 pt-10 md:px-8 md:pt-14" data-id="element-961" data-mp="327ce76ra6xpq">
          <div className="flex flex-wrap items-end justify-between gap-x-10 gap-y-3" data-id="element-962" data-mp="369h1zov1t04g">
            <h1 className="max-w-3xl font-serif text-[2rem] leading-[1.1] text-ink md:text-[2.75rem]" data-id="element-963" data-mp="33ylpkk6xzucr">
              A running count of the machine population, set against our own.
            </h1>
            <p className="font-mono text-[11.5px] text-muted" data-id="element-964" data-mp="2u8sh3s23jvcq">Compiled {COMPILED_LABEL} · extrapolated from dated bases</p>
          </div>

          <div className="mt-10 grid border-y border-line md:grid-cols-2 md:divide-x md:divide-line" data-id="element-965" data-mp="2p963vim9qf3x">
            <CounterPanel kind="human" title="Humans" subtitle="World population" base={HUMANS.base} baseTime={HUMANS.baseTime} ratePerSec={HUMANS.ratePerSec} sourceId={HUMANS.sourceId} rateLabel="+2.2 / sec" footnote={`base ${formatInt(HUMANS.base)}, Oct 2026`} data-id="element-966" data-mp="2kbntrowiltuc" />
            <div className="border-t border-line md:border-t-0" data-id="element-967" data-mp="9ib5w1zz27sp">
              <CounterPanel kind="machine" title="Machines" subtitle={scenario.short} base={scenario.count} baseTime={HUMANS.baseTime} ratePerSec={scenario.ratePerSec} sourceId={scenario.sourceIds[0]} rateLabel={<>
                    +{scenario.ratePerSec} / sec
                    <SourceRef id="fermi" estimate={{
                low: `${(scenario.ratePerSec / 2).toFixed(1)}/s`,
                high: `${scenario.ratePerSec * 2}/s`
              }} note="Assumed growth rate — our estimate." data-id="element-969" data-mp="1u1x2km4psjyp" />
                  </>} footnote={`range ${formatCompact(scenario.low)}–${formatCompact(scenario.high)}`} data-id="element-968" data-mp="4j8892mbn3ur" />
            </div>
          </div>

          <div className="mt-8" data-id="element-970" data-mp="2cr3glvukcne6">
            <ScenarioSwitcher data-id="element-971" data-mp="2cq219f6ileqn" />
          </div>
          <RatioGauge data-id="element-972" data-mp="wd3gokvpwxqx" />
        </div>
      </section>
      <QuickStats data-id="element-973" data-mp="wcbxk9jb4shj" />
      <PopulationBreakdown data-id="element-974" data-mp="wbse2oe0dw1e" />
      <AgentRatio data-id="element-975" data-mp="11c6o2bz67g22" />
    </>;
}